export const HEADER_HELP_MENU_ID = "headerHelpMenu";
export const HEADER_AVATAR_MENU_ID = "headerAvatarMenu";
export const HEADER_HELP_MENU_BUTTON_TEST_ID = "helpMenuButton";
export const HEADER_LOGOUT_BUTTON_TEST_ID = "logoutBtn";
